import { useMemo } from 'react';

export const useMapToIdList = (list = []) => {
  const idList = useMemo(() => {
    return list.map((listItem) => listItem.id);
  }, [list]);

  return idList;
};
